import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';
import React, { FC } from 'react';
import COButton from 'shared/components/COButton';
import OrganizationModal from 'shared/components/OrganizationModal';
import styles from './switchAlert.module.scss';

interface SwitchAlertOfMonthlyDataModalProps {
  isModalOpen: boolean;
  handleSubmit: () => void;
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  sourceValue?: ScopeData;
}

const SwitchAlertOfMonthlyDataModal: FC<SwitchAlertOfMonthlyDataModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  handleSubmit,
  sourceValue = new ScopeData(),
}) => {
  const { isYearly } = sourceValue;
  const handleClose = () => setIsModalOpen?.(false);

  return (
    <div className={styles.monthlyModalContainer}>
      <OrganizationModal
        visible={isModalOpen}
        onClose={handleClose}
        width={400}
        children={
          <div className={styles.alertContainer}>
            <div className={styles.alertTitleContainer}>
              Are you sure you want to Switch to{' '}
              {isYearly ? 'monthly' : 'annually'}
            </div>
            <div className={styles.alertInfoContainer}>
              Switching to {isYearly ? 'monthly' : 'annually'} will result in
              the loss of {isYearly ? 'annual' : 'monthly'} data
            </div>
            <div className={styles.buttonContainer}>
              <COButton
                danger
                children={isYearly ? 'Switch to monthly' : 'Switch to annually'}
                onClick={handleSubmit}
              />
              <COButton secondary children="Go back" onClick={handleClose} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default SwitchAlertOfMonthlyDataModal;
